
import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: "如何选择适合自己的茶叶？",
      answer: "选择茶叶需要考虑个人口感偏好、饮茶习惯、身体状况等因素。我们的专家会通过详细沟通了解您的需求，包括喜欢的口感（清淡/浓郁）、饮茶时间、预算范围等，然后为您推荐最适合的茶叶品种和等级。"
    },
    {
      question: "咨询服务是免费的吗？",
      answer: "基础咨询服务完全免费，包括茶叶选购建议、基础冲泡指导等。深度咨询服务如一对一品鉴培训、投资收藏指导、定制化方案等会收取相应费用，具体价格会在服务前明确告知。"
    },
    {
      question: "专家的资质如何保证？",
      answer: "我们的专家团队均持有国家级茶艺师、品鉴师等权威认证，拥有平均20年以上的行业经验。所有专家都经过严格筛选和培训，具备深厚的茶叶专业知识和丰富的实践经验。"
    },
    {
      question: "可以提供上门服务吗？",
      answer: "针对高端客户，我们提供上门茶艺指导和品鉴服务。服务范围主要覆盖一线城市及部分二线城市，具体可咨询客服了解您所在地区是否在服务范围内。"
    },
    {
      question: "如何预约专家咨询？",
      answer: "您可以通过多种方式预约：1. 填写在线预约表单；2. 拨打咨询热线400-888-6666；3. 添加微信客服shunnianchen888；4. 发送邮件至service@shunnianchen.com。我们会在24小时内回复并安排合适的专家为您服务。"
    },
    {
      question: "茶叶品质如何保证？",
      answer: "我们建立了完善的品质控制体系，所有茶叶均来自优质产区，经过严格的质量检测。我们提供品质保证，如对产品不满意，支持7天无理由退换货。同时，我们的专家会为您详细介绍每款茶叶的特点和冲泡方法。"
    },
    {
      question: "是否提供茶具推荐服务？",
      answer: "是的，我们不仅提供茶叶咨询，还会根据您选择的茶叶类型推荐适合的茶具。包括紫砂壶、盖碗、茶杯等的选择建议，以及茶具的使用和保养指导，帮助您获得最佳的品茶体验。"
    },
    {
      question: "支持企业团体咨询吗？",
      answer: "当然支持。我们为企业提供专业的茶文化培训、团建活动策划、商务茶礼定制等服务。可以根据企业需求定制专属的茶文化解决方案，提升企业文化品味和员工福利。"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 标题区域 */}
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-4xl font-bold text-[#663333] mb-4">
            常见问题
          </h2>
          <p className="text-sm sm:text-xl text-gray-600">
            解答您关于茶叶咨询服务的疑问
          </p>
        </div>

        {/* FAQ列表 */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden"
            >
              <button
                className="w-full px-6 lg:px-8 py-6 text-left focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-2"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-sm sm:text-base lg:text-lg font-semibold text-[#663333] pr-4">
                    {faq.question}
                  </h3>
                  <div className="flex-shrink-0">
                    <i 
                      className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-xl text-[#cc9966] transition-transform duration-300`}
                    ></i>
                  </div>
                </div>
              </button>
              
              <div className={`transition-all duration-300 ease-in-out ${
                openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
              } overflow-hidden`}>
                <div className="px-6 lg:px-8 pb-6">
                  <p className="text-xs sm:text-sm lg:text-base text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
